export default __webpack_public_path__ + "static/5Paz-5b8795b9249a7163dc09b08811403057.png";